import Reveal from "./Reveal";
import { Container, Eyebrow } from "./Primitives";

const AREAS = [
  { title: "Build an AI agent or assistant", body: "Purpose-built assistants grounded in your own processes and knowledge." },
  { title: "Connect Claude or ChatGPT to my tools", body: "Put the AI tools your team already uses to work inside your systems." },
  { title: "Automate repetitive work", body: "Remove manual handoffs, re-keying and status chasing." },
  { title: "Get more leads and follow up", body: "Capture enquiries, respond faster and keep your CRM accurate." },
  { title: "Answer customer questions faster", body: "Help your team reply consistently and stay responsive." },
  { title: "Schedule appointments and reminders", body: "Reduce back-and-forth booking and missed appointments." },
  { title: "Simplify patient intake", body: "Ease the paperwork and admin around new patients." },
  { title: "Streamline legal client intake", body: "Organize enquiries, conflict checks and onboarding steps." },
  { title: "Find answers in business documents", body: "Make policies, contracts and internal knowledge easier to search." },
  { title: "Simplify invoicing and accounting", body: "Cut manual work in invoicing, reconciliation and reporting." },
  { title: "Connect my systems", body: "Help the tools you already use share information." },
  { title: "Modernize my business", body: "Update dated processes and tools around how you work today." },
  { title: "Automate donor engagement", body: "Keep donor follow-up timely while communications stay personal." },
  { title: "Discover where AI can help", body: "Identify practical opportunities before committing to a build." },
];

const WIDE = new Set([0, 3, 7, 10]);

export default function Solutions() {
  return (
    <section id="solutions" className="fa-sheet relative z-10 -mt-10 overflow-hidden bg-canvas py-28 sm:py-36">
      <div aria-hidden className="fa-ambient fa-ambient--low" />
      <Container className="relative">
        <Reveal>
          <Eyebrow>Solutions</Eyebrow>
          <h2 className="mt-6 max-w-2xl font-display text-4xl font-light leading-[1.02] tracking-[-0.04em] text-fg sm:text-5xl">
            Where we typically help.
          </h2>
          <p className="mt-5 max-w-2xl text-base text-subtle md:text-lg">
            Every engagement starts from your problem. These are common starting points, not a fixed menu.
          </p>
        </Reveal>
        <ul className="mt-12 grid gap-2.5 sm:grid-cols-2 lg:grid-cols-3">
          {AREAS.map((a, i) => (
            <Reveal as="li" key={a.title} delay={(i % 3) * 90} className={`fa-tile group relative overflow-hidden rounded-2xl border border-line bg-canvas p-5 sm:p-6 ${WIDE.has(i) ? "lg:col-span-2" : ""}`}>
              <span className="font-mono text-[11px] tracking-[0.2em] text-tone">{String(i + 1).padStart(2, "0")}</span>
              <h3 className="mt-3 font-display text-[17px] font-normal leading-snug tracking-[-0.01em] text-fg">{a.title}</h3>
              <p className="mt-1.5 text-[14px] leading-relaxed text-subtle">{a.body}</p>
              <span aria-hidden className="fa-tile-line" />
            </Reveal>
          ))}
        </ul>
      </Container>
    </section>
  );
}
